module.exports = __webpack_public_path__ + "static/media/WelcomeBuddy.dd93bf25.png";